// extracted by mini-css-extract-plugin
module.exports = {"container":"PageProvider_container__9rBi7"};